var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRice = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22V10",
    stroke: "#6B8E23",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 10 14 8 14 5C14 3 12 2 12 2C12 2 10 3 10 5C10 8 12 10 12 10Z",
    fill: "#A8D5BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13C8.5 13 7 11 5.5 11C4 11 4 12.5 4 12.5C4 12.5 5 14 7 14C9 14 8.5 13 8.5 13Z",
    fill: "#A8D5BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13C15.5 13 17 11 18.5 11C20 11 20 12.5 20 12.5C20 12.5 19 14 17 14C15 14 15.5 13 15.5 13Z",
    fill: "#A8D5BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C7.5 15.5 5.5 16 5.5 16C5.5 16 6 18 8 18.5C10 19 9 16.5 9 16.5Z",
    fill: "#A8D5BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5C16.5 15.5 18.5 16 18.5 16C18.5 16 18 18 16 18.5C14 19 15 16.5 15 16.5Z",
    fill: "#A8D5BA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rice.514cf676249d67b4abe2b227c451616e.svg";